"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
Object.defineProperty(exports, "DropdownToggle", {
    enumerable: true,
    get: function() {
        return DropdownToggle;
    }
});
const _react = /*#__PURE__*/ _interop_require_wildcard(require("react"));
const _Button = require("../../Button/Button");
const _Dropdown = require("../Dropdown");
const _useHtmlId = require("../../../hooks/useHtmlId");
function _getRequireWildcardCache(nodeInterop) {
    if (typeof WeakMap !== "function") return null;
    var cacheBabelInterop = new WeakMap();
    var cacheNodeInterop = new WeakMap();
    return (_getRequireWildcardCache = function(nodeInterop) {
        return nodeInterop ? cacheNodeInterop : cacheBabelInterop;
    })(nodeInterop);
}
function _interop_require_wildcard(obj, nodeInterop) {
    if (!nodeInterop && obj && obj.__esModule) {
        return obj;
    }
    if (obj === null || typeof obj !== "object" && typeof obj !== "function") {
        return {
            default: obj
        };
    }
    var cache = _getRequireWildcardCache(nodeInterop);
    if (cache && cache.has(obj)) {
        return cache.get(obj);
    }
    var newObj = {
        __proto__: null
    };
    var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;
    for(var key in obj){
        if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) {
            var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;
            if (desc && (desc.get || desc.set)) {
                Object.defineProperty(newObj, key, desc);
            } else {
                newObj[key] = obj[key];
            }
        }
    }
    newObj.default = obj;
    if (cache) {
        cache.set(obj, newObj);
    }
    return newObj;
}
const DropdownToggle = /*#__PURE__*/ _react.default.forwardRef((param, ref)=>{
    let { children, ...props } = param;
    const { show, setShow, reference, refs, setToggleId } = (0, _react.useContext)(_Dropdown.DropdownContext);
    const id = (0, _useHtmlId.useHtmlId)(props.id);
    (0, _react.useEffect)(()=>{
        setToggleId(id);
    }, [
        id,
        setToggleId
    ]);
    (0, _react.useImperativeHandle)(ref, ()=>({
            click: ()=>{
                if (refs.reference.current instanceof HTMLButtonElement) {
                    refs.reference.current.click();
                }
            },
            focus: ()=>{
                if (refs.reference.current instanceof HTMLButtonElement) {
                    refs.reference.current.focus();
                }
            }
        }));
    return /*#__PURE__*/ _react.default.createElement(_react.default.Fragment, null, /*#__PURE__*/ _react.default.createElement(_Button.Button, {
        ...props,
        ref: reference,
        onClick: ()=>{
            setShow(!show);
        },
        id: id,
        dropdownToggle: true,
        "aria-expanded": show ? "true" : "false"
    }, children));
});
DropdownToggle.displayName = "DropdownToggle";

//# sourceMappingURL=DropdownToggle.js.map